import React from 'react';

const Circle = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.75" y="-0.75" width="22.5" height="22.5" rx="11.25" transform="matrix(1 0 0 -1 0 22.5)" stroke="#E0E0E0" strokeWidth="1.5"/>
  </svg>
);

export default Circle;
